import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { NavigationDemoComponent } from './navigation-demo/navigation-demo.component';
import { NavigationModule } from '../navigation.module';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatCardModule, NavigationModule],
  declarations: [NavigationDemoComponent],
  entryComponents: [NavigationDemoComponent]
})
export class NavigationDemoModule {}
